import type { CSSProperties } from 'react';

export const RIGHT_SECTION_WIDTH =
  'calc(var(--input-height) - calc(0.125rem * var(--mantine-scale)))';

export const CLEAR_BUTTON_STYLE: CSSProperties = {
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
};
